module.exports = __webpack_public_path__ + "static/media/dinosaur(7).ed454ab2.PNG";